import React, { Component } from 'react';
// import RepositorySelectorAddEdit from './repository_selector_addedit';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, message, Popconfirm, Icon } from 'antd';
import Title from 'antd/lib/typography/Title';
import { showErrorInNotification, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import RepositorySelectorEdit from './repository_selector_edit';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import ErrorWrapper from '../../../lib/error_wrapper';
import { Link } from 'react-router-dom';

const queryString = require('query-string');


const selector_cols = ({ onEditPressed, onDeletePressed,repository_id }) => [
    {
        title: "Name",
        dataIndex: 'name',
        className:'bold-cell'
    }, 
    {
        title: "Selector",
        dataIndex: 'selector'
    }, {
        title: "",
        dataIndex: 'id',
        render: (id, data) => {
            return <span>
                <Link to={`/settings/data-repository/${repository_id}/selectors/${id}/edit`}>

                <Button type='link' onClick={() => {
                    // typeof onEditPressed === 'function' && onEditPressed(data);
                }}>Edit</Button>
                </Link>
                <Divider type='vertical' />
                <Popconfirm title="Are you sure you want to delete this selector?" onConfirm={()=>{
                    typeof onDeletePressed === 'function' && onDeletePressed(data);
                }}>
                <Button type='link' style={{color:'red'}}>Delete</Button>
                </Popconfirm>
            </span>
        }
    }

]

class RepositorySelectorList extends Component {
    constructor(props) {
        super(props);
        this.repository_id = props.match.params.repository_id;

        this.state = {
            edit_selector_id: null,
            add_edit_status: null,
            edit_selector_data: null,
            repository_id:this.repository_id,
            filter_query:{}
        };
        this.list_selectors = RESTExecutor.list().config({
            label: 'selectors'
        }).forId(this.repository_id).connect(props.domains.datarepository);

        this.delete_selector=RESTExecutor.delete().config({
            label:'selectors_detail',
            params:{
                repository_id:"",
                selector_id:""
            }
        }).callbacks((success)=>{
            message.success("Selector Deleted");
            this.list_selectors.execute()
        },(error)=>{
            showErrorInNotification(error);
        }).connect(props.domains.datarepository);

        // this.list_selectors.execute();
    };

    render() {
        let list_selectors_resp = this.list_selectors.response();
        let list_selectors_data = list_selectors_resp.result || {};
        let rowsData = list_selectors_data.rows || [];
        let rowsMeta = list_selectors_resp.meta || {};

        return (
            <div>
            <BasicHeader 
            title="Selectors"
            right={[
                <Link to={`/settings/data-repository/${this.repository_id}/selectors/add`}>
               
                <TransparentButton
                    label="Add New"
                    className='cta-primary'
                    hint="Add New Data Repository"
                    // onClick={() => {
                    //     this.setState({
                    //         add_edit_status: 'add'
                    //     })
                    // }}
                />
                 </Link>
            ]}
            />

            <ErrorWrapper
            error={list_selectors_resp}
            onReload={()=>{
                this.list_selectors.execute()
            }}
            >

            <div className='default-card' style={{ padding: 0 }}>
                {/* <CustomHeader/> */}
                <Table
                scroll={{x:true}}
                    className='main-table'
                    loading={list_selectors_resp.fetching}
                    size='small'

                    pagination={{
                        simple: false,
                    position:'bottom',
                        onChange: (current, size) => {
                            this.list_selectors.config({
                                params: {
                                    per_page: size,
                                    page: current
                                }
                            }).execute();
                        },
                        defaultCurrent: 1,
                        current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        // defaultPageSize: 20,
                        pageSize: (rowsMeta && rowsMeta.requested_count),

                        total: (rowsMeta && rowsMeta.total_count),
                        showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                    // bordered={false}
                    rowKey={(record) => record.id}
                    columns={selector_cols({
                        onEditPressed: (data) => {
                            this.setState({
                                edit_selector_id: data.id,
                                edit_selector_data: JSON.parse(JSON.stringify(data)),
                                add_edit_status: 'edit'
                            })
                        },
                        onDeletePressed:(data)=>{
                            this.delete_selector.config({
                                params:{
                                    repository_id:this.repository_id,
                                    selector_id:data.id
                                }
                            }).execute()
                        },
                        repository_id:this.repository_id
                    })}
                    dataSource={rowsData}
                />

                {/* For Fetcher Config Add */}
                <Drawer
                    title="Selector Add"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null
                        });
                        this.list_selectors.execute()
                    }}
                    visible={this.state.add_edit_status === 'add'}
                >
                    {/* <RepositorySelectorAddEdit
                        repository_id={this.state.repository_id}
                        onClose={() => {
                            this.setState({
                                add_edit_status: null,
                            });
                            this.list_selectors.execute()
                        }}
                        onCloseReload={()=>{
                            this.list_selectors.execute();
                            this.setState({
                                add_edit_status: null,
                                edit_selector_id: null,
                                edit_selector_data: {},
                            })
                        }}

                    /> */}
                </Drawer>
                <Drawer
                    title="Selector Edit"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null,
                            edit_selector_id:null,
                            edit_selector_data:{}
                        });
                        this.list_selectors.execute()
                    }}
                    visible={this.state.add_edit_status === 'edit'}
                >
                    <RepositorySelectorEdit
                        edit_id={this.state.edit_selector_id}
                        // edit_data={this.state.edit_selector_data}
                        repository_id={this.state.repository_id}
                        onCloseReload={()=>{
                            this.list_selectors.execute();
                            this.setState({
                                add_edit_status: null,
                                edit_selector_id: null,
                                edit_selector_data: {},
                            })
                        }}
                        onClose={() => {
                            this.setState({
                                add_edit_status: null,
                                edit_selector_id:null,
                            edit_selector_data:{}
                            });
                            this.list_selectors.execute()
                        }}
                    />
                </Drawer>
            </div>
            </ErrorWrapper>

        
            </div>
        );


    }
    componentDidMount(){
        overrideHeaderTitle("Selector List");
        overrideHeaderBack('/settings/data-repository')
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
                ...new_filter_query
            }
        }, () => {
            this.list_selectors.execute()
            // this.list_packets.config({
            //     params: {
            //     ...this.state.filter_query
            //     }
            // }).execute()
        })
    }
    componentWillUnmount(){
        overrideHeaderBack(null)
    }
    
    componentWillReceiveProps(nextProps) {
        var oldrepository_id = this.props.match.params.repository_id;
        var newrepository_id = nextProps.match.params.repository_id;




        if (oldrepository_id !== newrepository_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.datatype = newrepository_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    // dateTo: moment().format(defaultDateFormat),
                    ...parsed
                },
            }, () => {
                // if (olddatatype_id !== newdatatype_id) {
                //     this.setState({
                //         loading: true
                //     }, () => {
                //         this.datatype_detail.forId(this.datatype).execute()
                //     })
                // } else {
                    this.list_selectors.forId(this.repository_id).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                // }



            })

        }
    }
}

export default withDomains(RepositorySelectorList, "datarepository");
